import { checkTypeExam } from './convertType'
import { enterOtherTesting } from './action/actionPathToTesting/pathExam'
import { enterOldTesting } from './action/actionPathToTesting/pathOldExam'
import { enterGroupTesting } from './action/actionPathToTesting/pathGroupExam'
import { enterRandomTesting } from './action/actionPathToTesting/pathRandomTesting'
import { enterSuggestionExam } from './action/actionPathToTesting/pathSuggestionExam'


export const genExam = (user, props, data) => {
  switch (new ExamClass(user, props, data).convertType) {
    case 'RandomExam':
      return new RandomExam(user, props, data)
    case 'PracticeExam':
      return new RandomExam(user, props, data)
    case 'O-NetExam':
      return new RandomExam(user, props, data)
    case 'PreSecondarySchool':
      return new RandomExam(user, props, data)
    case 'LessonExam':
      return new RandomExam(user, props, data)
    case 'OldExam':
      return new OldExam(user, props, data)
    case 'GroupExam':
      return new GroupExam(user, props, data)
    case 'SuggestionExam':
      return new SuggestionExam(user, props, data)
    case 'FreeExam':
      return new ExamClass(user, props, data)
    case 'TeacherMyExam':
      return new ExamClass(user, props, data)
    case 'PretestExam':
      return new ExamClass(user, props, data)
    case 'BookmarkExam':
      return new BookmarkExam(user, props, data)
    default:
      return new ExamClass(user, props, data)
  }
}

class ExamClass {
  constructor(user, props, data) {
    this.user = user
    this.props = props
    this.data = data
  }
  get convertType() { return checkTypeExam(this.user, this.props, this.data) }
  get enterExam() { return enterOtherTesting(this.user, this.props, this.data) }
}

class OldExam extends ExamClass {
  get enterExam() { return enterOldTesting(this.user, this.props, this.data) }
}

class GroupExam extends ExamClass {
  get enterExam() { return enterGroupTesting(this.props, this.data) }
}

class RandomExam extends ExamClass {
  get enterExam() { return enterRandomTesting(this.props, this.data) }
}
class SuggestionExam extends ExamClass {
  get enterExam() { return enterSuggestionExam(this.user, this.props, this.data) }
}

class BookmarkExam extends ExamClass {
  get enterExam() { return enterSuggestionExam(this.user, this.props, this.data) }
}
